import React from 'react';
import { TextElement } from '../../schema/text.schema';
import styles from '../../assets/css/text.module.css';
import { Box } from '@mui/material';
import { TextBoxDanger } from './TextBoxDanger';

interface TextComponentProps {
	element: TextElement;
}

const TextComponent: React.FC<TextComponentProps> = ({ element }) => {
	const { content, tags } = element;

	const combinedStyle = tags.map((tag) => TAG_CLASS_MAP[tag as keyof typeof TAG_CLASS_MAP]).join(' ');

	if (tags.includes('BOX_DANGER')) {
		return (
			<Box className={styles['text-container']}>
				<TextBoxDanger content={content} />
			</Box>
		);
	}

	return (
		<Box className={styles['text-container']}>
			<Box className={combinedStyle}>{content}</Box>
		</Box>
	);
};

export default TextComponent;

const TAG_CLASS_MAP = {
	LEGAL: styles.legal,
	QUOTE: styles.quote,
	HELPTEXT: styles['help-text-container'],
	LIST: styles['list-box'],
	BOX_SUCCESS: styles['text-box-success'],
	BOX_INFO: styles['text-box-info'],
	BOX_WARNING: styles['text-box-warning'],
	BOX_DANGER: styles['text-box-danger']
} as const;
